export function languageToCountry(lang) {
    let map = {
        en: 'gb',
        da: 'dk',
        sv: 'se',
        'en_GB': 'gb',
        'de_AT': 'at',
        'de_CH': 'ch',
    };

    if (map[lang] !== undefined) {
        return map[lang];
    }

    return lang;
}
